import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import { useMemo } from 'react';

import { FullWidthContainer } from '@sorare/core/src/atoms/layout/FullWidthContainer';
import { SaleType, createCardSorts } from '@sorare/core/src/lib/algolia';
import { useDefaultFilters } from '@sorare/marketplace/src/hooks/useDefaultFilters';
import { clubPageFilters } from '@sorare/marketplace/src/searchCards/mlb/cardFilters';

import { BaseballCardSearch as AdvancedCardSearch } from '#src/components/searchCards/BaseballCardSearch/index.tsx';

import type { BaseballTeamSearch_teamInterface } from './__generated__/index.graphql.ts';

type Props = {
  team: BaseballTeamSearch_teamInterface;
};

const cardSorts = createCardSorts({ withHighestAverageScore: true });
export const Search = ({ team }: Props) => {
  const filters = useDefaultFilters({
    teamSlug: team.slug,
  });

  const cardFilters = useMemo(() => clubPageFilters(false), []);

  return (
    <FullWidthContainer>
      <AdvancedCardSearch
        sorts={cardSorts}
        defaultSort="Newly Listed"
        analyticsTags={['Team', 'Baseball']}
        topic={{ type: 'team', label: team.name }}
        defaultFilters={filters}
        cardFilters={cardFilters}
        stackableTypes={[SaleType.PRIMARY_OFFER]}
      />
    </FullWidthContainer>
  );
};

Search.fragments = {
  team: gql`
    fragment BaseballTeamSearch_teamInterface on TeamInterface {
      slug
      name
    }
  ` as TypedDocumentNode<BaseballTeamSearch_teamInterface>,
};
